import { Skeleton } from '@mui/material';
import { PropsWithChildren } from 'react';
import styles from './Video.module.scss';
import skeletonStyles from './VideoSkeletons.module.scss';
import { classes } from '../../../../lib/utils/cssUtils';

export const VideoChaptersSkeleton = ({
  isLoading,
  isEmpty,
  children,
}: PropsWithChildren<{ isLoading?: boolean; isEmpty?: boolean }>) => {
  if (isEmpty) {
    return null;
  }
  if (isLoading === false) {
    return children;
  }

  return (
    <div className={styles.chaptersContainer}>
      <Skeleton variant="text" className={skeletonStyles.chaptersHeading} />
      <div className={skeletonStyles.chaptersList}>
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
      </div>
    </div>
  );
};

export const VideoPlayerSkeleton = () => {
  return (
    <div>
      <Skeleton variant="rounded" className={skeletonStyles.top} />
      <Skeleton variant="rounded" className={skeletonStyles.player} />
      <div>
        <Skeleton variant="text" className={classes(styles.videoTitle, skeletonStyles.playerTitle)} />
        <Skeleton variant="text" className={classes(styles.videoDescription, skeletonStyles.playerDescription)} />
      </div>
    </div>
  );
};
